import { render, staticRenderFns } from "./ListWithBackgroundImage.vue?vue&type=template&id=20222dc1&"
import script from "./ListWithBackgroundImage.vue?vue&type=script&lang=js&"
export * from "./ListWithBackgroundImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports